module.exports = __webpack_public_path__ + "static/img/GT.384ca612.jpg";